
import { Component, Vue } from "vue-property-decorator";
// import * as bindobject from "@/common/bindobject";
import { SystemConfigModule } from "@/store/modules/store_systemconfig";
const packageInfo = require("../appversion.json");

@Component({
  name: "App",
})
export default class extends Vue {
  created() {
    // await bindobject.regist();
    this.copyRightConsole(packageInfo);
  }
  mounted() {
    try {
      if (typeof obj_GlobalData_Core !== "undefined") {
        SystemConfigModule.setGlobalData(
          JSON.parse(obj_GlobalData_Core.getGlobalData())
        );
        SystemConfigModule.setSystemData(
          JSON.parse(obj_GlobalData_Core.getSystemConfig())
        );
        SystemConfigModule.setLoginData(
          JSON.parse(obj_GlobalData_Core.getLoginData())
        );
        console.log("初始化成功");
      } else {
        console.log("初始化失败：obj_GlobalData_Core 未定义");
      }
    } catch (error) {
      console.error("初始化异常：");
      console.error(error);
    }
  }
  // 在console中显示信息
  copyRightConsole(packageInfo) {
    /* 样式代码 */
    const projectNameStyle =
      "font-size: 20px;font-weight: 600;color: rgb(52,69,140);";
    const descriptionStyle =
      "font-style: oblique;font-size:14px;color: rgb(239,186,78);font-weight: 400;";
    const versionStyle = "color: rgb(30,152,255);padding:8px 0 2px;";
    const contentStyle = "color: rgb(30,152,255);padding:0 0 2px;";
    const dateTimeStyle = "color: rgb(30,152,255);padding:0 0 5px;";

    /* 内容代码 */
    const projectName = packageInfo.name || "";
    const description = packageInfo.description || "";
    const version = `版 本 号：${packageInfo.version}`;
    // const dateTime = `编译日期：${moment().format('YYYY-MM-DD HH:mm:ss')}`;
    // const releaseDateTime = `发布时间：${moment(window.releaseDateTime).format('yyyy-MM-DD HH:mm:ss')}`;
    const dateTime = `编译时间：${packageInfo.compilationDateTime}`;
    const info = `备注信息：${packageInfo.info}`; //`发布时间：${123123123}`;

    // 空格有意义，不要格式化
    console.log(
      `%c${projectName} %c${description} 
%c${version}
%c${dateTime}
%c${info}`,
      projectNameStyle,
      descriptionStyle,
      versionStyle,
      dateTimeStyle,
      contentStyle
    );
  }
}
